import React, { useEffect, useState } from "react";
import "./Admindashboard.css";
import Header from "../../Components/Header/Header";
import CreateTask from "../../Components/CreateTask/CreateTask";
import AllTask from "../../Components/AllTask/AllTask";
import axios from "axios";

function Admindashboard({ changeUser }) {
  // ================================
  const [chartData, setChartData] = useState({
    labels: ["Active", "Accepted", "Failed", "Success"],
    datasets: [
      {
        data: [30, 50, 100, 120],
        backgroundColor: ["rgb(244, 181, 65)", "#6fa9fb", "tomato", "#61d977"], // Colors for each section
        borderColor: ["#ffffff", "#ffffff", "#ffffff", "#ffffff"], // Border color (white here)
        borderWidth: 1, // Border width for each section
      },
    ],
  });
  // ==================================

  const [allData, setAllData] = useState(null);
  const [showId, setShowId] = useState();
  const [asignTo, setAsignTo] = useState("");
  useEffect(() => {
    axios
      .get("https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2")
      .then((success) => {
        setAllData(success.data);
      })
      .catch((error) => {
        setAllData(error);
      });
  }, []);

  return (
    <>
      {allData && (
        <div className="admin_bg">
          <div>
            <Header />
          </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 col-lg-2 py-3 sep-left">
                  <AllTask
                    authEmployeeData={allData}
                    setShowId={setShowId}
                    asignTo={asignTo}
                    setAsignTo={setAsignTo}
                    setChartData={setChartData}
                  />
                </div>
                <div className="col-md-8 col-lg-10">
                  <CreateTask
                    data={allData}
                    setAllData={setAllData}
                    showId={showId}
                    asignTo={asignTo}
                    setAsignTo={setAsignTo}
                    chartData={chartData}
                  />
                </div>
              </div>
            </div>
        </div>
      )}
    </>
  );
}

export default Admindashboard;
